import { render, staticRenderFns } from "./SpaceChallengesTab.vue?vue&type=template&id=60785875&scoped=true"
import script from "./SpaceChallengesTab.vue?vue&type=script&lang=js"
export * from "./SpaceChallengesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60785875",
  null
  
)

export default component.exports